const { AbilityBuilder } = require('casl');

import {
  READ_PERMISSION,
  ANALYTICS_MODULE
} from '@/permission-constants.js';

// user role based permission
function defineAbilitiesFor(userRole) {
  return AbilityBuilder.define((allow, forbid) => {
    switch (userRole) {
      case 'admin':
        allow(READ_PERMISSION, ANALYTICS_MODULE);
        break;
      // case 'user':
      //   forbid(READ_PERMISSION, ANALYTICS_MODULE);
      //   break;
    }
  });
}

export function evaluatePermission(userroles, permission, module) {

  var isAllowed = false;

  for (let i = 0; i < userroles.length; i++) {
    let alibilites = defineAbilitiesFor(userroles[0]);
    if (alibilites.can(permission, module) == true) {
      isAllowed = true;
      break;
    }
  }

  return isAllowed;
}